<dx-data-grid class="p-2"
              noDataText="No Cultural Indexes"
              [dataSource]="data"
              [allowColumnResizing]="true"
              [allowColumnReordering]="true"
              [wordWrapEnabled]="true"
              [rowAlternationEnabled]="true"
              [hoverStateEnabled]="true"
              [showRowLines]="true"
              [showBorders]="true"
              [stateStoring]="dxGridHelper.stateStoringOptions"
              (onInitialized)="onGridInitialized($event)">
    <dxo-data-grid-column-fixing [enabled]="true"> </dxo-data-grid-column-fixing>
    <dxo-data-grid-pager [showPageSizeSelector]="true"
                         [allowedPageSizes]="[10, 25, 50, 100, 250]"> </dxo-data-grid-pager>
    <dxo-data-grid-paging [pageSize]="25"> </dxo-data-grid-paging>
    <dxo-data-grid-scrolling [useNative]="false"> </dxo-data-grid-scrolling>
    <dxo-data-grid-header-filter [visible]="true"> </dxo-data-grid-header-filter>
    <dxo-data-grid-filter-row [visible]="true"> </dxo-data-grid-filter-row>
    <dxo-data-grid-group-panel [visible]="true"> </dxo-data-grid-group-panel>
    <dxo-data-grid-grouping [autoExpandAll]="true"> </dxo-data-grid-grouping>
    <dxo-data-grid-load-panel [enabled]="true"> </dxo-data-grid-load-panel>
    <dxo-data-grid-export [enabled]="true"
                          fileName="Cultural Index Analysis"> </dxo-data-grid-export>

    <dxi-data-grid-column caption="Person"
                          dataField="person.fullName"
                          dataType="string"
                          cellTemplate="personCellTemplate"
                          [fixed]="true"
                          [width]="200"> </dxi-data-grid-column>

    <dxi-data-grid-column [caption]="culturalLeadershipConfiguration?.primaryName"
                          dataField="dummy_culturalleader"
                          dataType="string"
                          [calculateCellValue]="calculateCulturalLeadersCellValue"
                          [calculateGroupValue]="calculateCulturalLeadersGroupValue"
                          [customizeText]="culturalLeadersCustomizeText"
                          [groupIndex]="0"
                          [allowSorting]="true"
                          [allowGrouping]="true"
                          [allowFiltering]="true"
                          cellTemplate="culturalLeaderCellTemplate"
                          groupCellTemplate="culturalLeaderGroupCellTemplate"
                          [width]="200">
        <dxo-data-grid-header-filter [dataSource]="culturalLeadersHeaderItems"></dxo-data-grid-header-filter>
    </dxi-data-grid-column>

    <dxi-data-grid-column caption="Cultural Index"
                          dataField="culturalIndex.value"
                          dataType="number"
                          [customizeText]="culturalIndexUiService.customiseValueCellText"
                          [cellTemplate]="culturalIndexUiService.getValueCellTemplate"
                          [width]="150"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Direction"
                          dataField="culturalIndex.direction"
                          dataType="string"
                          [width]="120">
        <dxo-data-grid-lookup [dataSource]="culturalIndexService.directions"
                              valueExpr="id"
                              displayExpr="label"> </dxo-data-grid-lookup>
    </dxi-data-grid-column>

    <dxi-data-grid-column caption="Date"
                          dataField="culturalIndex.creationDate"
                          dataType="date"
                          [format]="DateFormats.globalize.short"
                          [width]="100"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Notes"
                          dataField="culturalIndex.notes"
                          cellTemplate="richTextTemplate"
                          dataType="string"
                          [encodeHtml]="false"> </dxi-data-grid-column>

    <div *dxTemplate="let item of 'personCellTemplate'">
        <adapt-link-person [person]="item.data.person"
                           nullValueText="(Anonymous person)"
                           [preventWrap]="true"></adapt-link-person>
    </div>
    <div *dxTemplate="let item of 'culturalLeaderCellTemplate'">
        <adapt-link-person [person]="item.data.culturalLeader"
                           [preventWrap]="true"
                           nullValueText="None allocated"></adapt-link-person>
    </div>
    <div *dxTemplate="let item of 'culturalLeaderGroupCellTemplate'">
        @if (!!item.value) {
            {{ culturalLeadershipConfiguration?.primaryName }}:
            <adapt-link-person [personId]="item.value"
                               [preventWrap]="true"></adapt-link-person>
        } @else {
            No {{ culturalLeadershipConfiguration?.primaryName }}
        }
    </div>
    <div *dxTemplate="let item of 'richTextTemplate'">
        <div [froalaView]="item.value"></div>
    </div>
</dx-data-grid>
